import { X } from 'lucide-react'
import type { ReactNode } from 'react'

interface TealBannerAction {
  label: string
  onClick: () => void
}

interface TealBannerProps {
  children: ReactNode
  onDismiss: () => void
  actions?: TealBannerAction[]
  position?: 'top' | 'inline'
}

export function TealBanner({ children, onDismiss, actions, position = 'top' }: TealBannerProps) {
  const isTop = position === 'top'

  return (
    <output
      className={`block bg-brand text-brand-foreground px-4 py-3 ${
        isTop ? 'fixed left-0 right-0 top-12 z-40' : ''
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 text-sm">{children}</div>
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 p-0.5 rounded hover:bg-white/20 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      {actions && actions.length > 0 && (
        <div className="flex gap-2 mt-2">
          {actions.map((action) => (
            <button
              key={action.label}
              type="button"
              onClick={action.onClick}
              className="text-sm font-medium px-3 py-1 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </output>
  )
}
